export const APP_AUDIENCES = Object.freeze(['parents', 'kids']);
export const STORE_PLATFORMS = Object.freeze(['ios', 'android']);

export const isValidStoreUrl = (value, platform) => {
  if (typeof value !== 'string' || !STORE_PLATFORMS.includes(platform)) return false;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return false;
    return platform === 'ios'
      ? url.hostname === 'apps.apple.com' && /\/id\d+\/?$/.test(url.pathname)
      : url.hostname === 'play.google.com' && url.pathname === '/store/apps/details' && Boolean(url.searchParams.get('id'));
  } catch {
    return false;
  }
};

export const findAvailableStoreLink = (links, audience, platform) => {
  const row = links?.find((link) => link.audience === audience && link.platform === platform);
  return row?.is_available === true && isValidStoreUrl(row.url, platform) ? row.url : null;
};
